import { Component, Host, h, Prop, Event, EventEmitter, Listen } from '@stencil/core';
import { SVGIcon } from '../icons/svg-icon';
import { DropdownItem } from '../dropdown-list/dropdown-list';
import classnames from 'classnames';

const MENU_OPTIONS: DropdownItem[] = [
  {
    external: true,
    href: 'https://episerver.zendesk.com/auth/v2/login/continue_with_sso_tracking?auth_origin=499034%2Ctrue%2Ctrue&brand_id=499034&locale=1&return_to=https%3A%2F%2F//support.optimizely.com/hc/requests/new%2F&role=end_user&theme=hc',
    text: 'Get Support',
  },
  { text: 'Documentation', heading: true },
  { text: 'User Documentation', external: true, href: 'https://support.optimizely.com/hc/en-us' },
  { text: 'Developer Documentation', external: true, href: 'https://docs.developers.optimizely.com' },
  { text: 'Training', heading: true },
  { text: 'Optimizely Academy', external: true, href: 'https://academy.optimizely.com' },
  { text: 'Resources', heading: true },
  // { text: 'Slack Community', external: true, href: 'https://www.optimizely.com/slack-community/' },
  { text: 'Optimizely Partners', external: true, href: 'https://www.optimizely.com/partners/' },
  { text: 'Give Product Feedback', external: true, href: 'https://feedback.optimizely.com/' },
  { text: 'Legal Notices', external: true, href: 'https://www.optimizely.com/legal/terms/' },
];

@Component({
  tag: 'opti-support-menu',
  styleUrl: 'opti-support-menu.scss',
  shadow: true,
})
export class OptiSupportMenu {
  @Prop() authenticated = false;

  @Event({
    eventName: '@opti-support-menu:select',
    composed: true,
    cancelable: true,
    bubbles: true,
  })
  select: EventEmitter<DropdownItem>;

  @Listen('opti-dropdown-list-selection')
  onItemSelection(event: CustomEvent<DropdownItem>) {
    this.select.emit(event.detail);
  }

  render() {
    const menuClasses = classnames('support__menu', {
      'support__menu--right': !this.authenticated,
    });

    return (
      <Host>
        <div class="support" tabIndex={0}>
          <button class="support__icon">
            <SVGIcon name="circle-question" />
          </button>
          <dropdown-list class={menuClasses} disableFilter items={MENU_OPTIONS}></dropdown-list>
        </div>
      </Host>
    );
  }
}
